import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  FaCaretRight as CaretRightIcon,
  FaCaretDown as CaretDownIcon,
  FaPlus as PlusIcon,
} from 'react-icons/fa';

import CustomNumeral from '../../../shared/customNumeral.component';
import { NumeralTypes } from '../../../shared/numeral.component';
import { BasicReportRowPropTypes } from '../propTypes';
import EffectiveTaxRateDetailLink from '../effectiveTaxRateDetailLink.component';

import EditableWrapper from './editableWrapper.component';
import Subrow from './subrow.component';
import { totalNegativePercentage } from '../utils/numeral.utils';
import GroupRow from './groupRow.component';
import GroupingColumns from '../GroupingColumns.component';

class GroupData extends PureComponent {
  static propTypes = {
    tagName: PropTypes.string.isRequired,
    tagDescription: PropTypes.string.isRequired,
    subrows: PropTypes.arrayOf(BasicReportRowPropTypes.isRequired).isRequired,
    columnsData: PropTypes.arrayOf(PropTypes.number).isRequired,
    ibtAmount: PropTypes.number.isRequired,
    fetchReport: PropTypes.func.isRequired,
    showDeletingDriverModal: PropTypes.func.isRequired,
    showAddRateDriver: PropTypes.bool.isRequired,
    suppressHidingDecimalPlacesForPercentage: PropTypes.bool,
    hideGroupingColumns: PropTypes.bool.isRequired,
    hasAnyCompanyCodesForManagingETRDrivers: PropTypes.func.isRequired,
    updateStickyElementsPosition: PropTypes.func.isRequired,
    displayGroupingColumnsByPercentages: PropTypes.bool.isRequired,
    toggleVisibility: PropTypes.func.isRequired,
    isOpen: PropTypes.bool.isRequired,
    path: PropTypes.arrayOf(PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ])).isRequired,
  };

  state = {
    addingNewRow: false,
    isOpen: false,
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (this.state.isOpen && prevState.isOpen !== this.state.isOpen) {
      this.props.updateStickyElementsPosition();
    }

    if (!this.props.showAddRateDriver) {
      this.closeNewRow();
    }
  };

  toggleGroup = event => {
    const { toggleVisibility, path } = this.props;
    event.preventDefault();
    toggleVisibility(path);
  };

  addNewRowForTag = event => {
    event.preventDefault();
    this.setState(({ addingNewRow }) => ({
      addingNewRow: !addingNewRow,
      isOpen: true,
    }));
  };

  closeNewRow = () => {
    this.setState({
      addingNewRow: false,
    });
  };

  render() {
    const {
      tagName,
      tagDescription,
      subrows,
      columnsData,
      ibtAmount,
      fetchReport,
      showDeletingDriverModal,
      showAddRateDriver,
      suppressHidingDecimalPlacesForPercentage,
      hideGroupingColumns,
      hasAnyCompanyCodesForManagingETRDrivers,
      updateStickyElementsPosition,
      displayGroupingColumnsByPercentages,
      isOpen,
      toggleVisibility,
      path,
    } = this.props;

    const {
      addingNewRow,
    } = this.state;

    const addNewIcon = <PlusIcon className="icon-plus" size={16} onClick={this.addNewRowForTag} />;

    const toggle = isOpen
      ? <CaretDownIcon className="icon-toggle" size={16} onClick={this.toggleGroup} />
      : <CaretRightIcon className="icon-toggle" size={16} onClick={this.toggleGroup} />;

    const total = subrows.reduce((acc, { amount }) => acc + amount, 0);
    const totalPercentage = total / ibtAmount;

    const parentRow = (
      <div className="row parent-row font-weight-bold expandable">
        <div className="etr-icon-wrapper stick-left">
          {(!addingNewRow && showAddRateDriver && hasAnyCompanyCodesForManagingETRDrivers(tagName)) && addNewIcon}
        </div>
        <div className="col-6 description stick-left pb-2">{toggle} <span onClick={this.toggleGroup}>{tagDescription}</span></div>
        <div className="col-2 text-right parent-amount-column">
          <EffectiveTaxRateDetailLink tagName={tagName} ibtAmount={ibtAmount}>
            <CustomNumeral type={NumeralTypes.DECIMAL}>{total}</CustomNumeral>
          </EffectiveTaxRateDetailLink>
        </div>
        <div className="col-2 text-right">
          <CustomNumeral
            additionalClassNames={totalNegativePercentage}
            type={NumeralTypes.PERCENT_4}
            suppressHidingDecimalPlaces={suppressHidingDecimalPlacesForPercentage}
          >
            {totalPercentage}
          </CustomNumeral>
        </div>
        <GroupingColumns
          hideGroupingColumns={hideGroupingColumns}
          columnsData={columnsData}
          sumForPercentagesCalculation={displayGroupingColumnsByPercentages ? ibtAmount : null}
          suppressHidingDecimalPlacesForPercentage={suppressHidingDecimalPlacesForPercentage}
          tagName={tagName}
          ibtAmount={ibtAmount}
          shouldRenderLink
        />
      </div>
    );

    const dataRows = subrows.map((row, index) => (
      <GroupRow
        nestingLevel={1}
        key={row.descr}
        tagName={tagName}
        rowData={row}
        fetchReport={fetchReport}
        showDeletingDriverModal={showDeletingDriverModal}
        ibtAmount={ibtAmount}
        suppressHidingDecimalPlacesForPercentage={suppressHidingDecimalPlacesForPercentage}
        hideGroupingColumns={hideGroupingColumns}
        updateStickyElementsPosition={updateStickyElementsPosition}
        displayGroupingColumnsByPercentages={displayGroupingColumnsByPercentages}
        toggleVisibility={toggleVisibility}
        isOpen={row.isOpen}
        path={[...path, 'subrows', index]}
      />
    ));

    const renderAddingNewRow = (
      <EditableWrapper>
        {changeEditable => (
          <Subrow
            tagName={tagName}
            fetchReport={fetchReport}
            closeNewRow={this.closeNewRow}
            showDeletingDriverModal={showDeletingDriverModal}
            suppressHidingDecimalPlacesForPercentage={suppressHidingDecimalPlacesForPercentage}
            hideGroupingColumns={hideGroupingColumns}
            updateStickyElementsPosition={updateStickyElementsPosition}
            changeEditableOnParent={changeEditable}
          />
        )}
      </EditableWrapper>
    );

    return (
      <div className={`data-rows-group`}>
        {parentRow}
        {isOpen && dataRows}
        {addingNewRow && renderAddingNewRow}
      </div>
    );
  }
}

export default GroupData;
